
const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const INTERVALS_VARIABLES = [
    { label: 'Just now', threshold: 0 },
    { label: '1 min ago', threshold: 60 },
    { label: '2 mins ago', threshold: 120 },
    { label: '%d mins ago', threshold: 60 * 60, divisor: 60 },
    { label: '1 hour ago', threshold: 3600 },
    { label: '2 hours ago', threshold: 7200 },
    { label: '%d hours ago', threshold: 24 * 3600, divisor: 3600 },
    { label: '1 day ago', threshold: 86400 },
    { label: '2 days ago', threshold: 2 * 86400 },
    { label: '%d days ago', threshold: 21 * 86400, divisor: 86400 },
    { label: '%d %b %Y', threshold: Infinity }
];

const timeSince = (date: any) => {
    if (!date) {
        date = new Date();
    }

    if (typeof date == "string") {
        date = new Date(date);
    }

    var seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);

    var interval = Math.floor(seconds / 31536000);

    if (interval >= 1) {
        //   return interval + " years";
        // return date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
        return "More than a year ago";
    }
    interval = Math.floor(seconds / 2592000);
    if (interval > 1) {
        return interval + " months ago";
        // return date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
    } else if (interval === 1){
        return interval + " month ago";
    }
    interval = Math.floor(seconds / 86400);
    if (interval > 1) {
        return interval + " days ago"
    } else if (interval === 1){
        return interval + " day ago"
    }
    interval = Math.floor(seconds / 3600);
    if (interval > 1) {
        return interval + " hours ago";
    } else if (interval === 1) {
        return interval + " hour ago";
    }
    interval = Math.floor(seconds / 60);
    if (interval >= 1) {
        return interval + " min ago";
    }
    return "Just Now";
}

const timeDate = (date: any) => {
    if (!date) {
        date = new Date();
    }

    if (typeof date == "string") {
        date = new Date(date);
    }

    let d = date;
    let h = d.getHours();
    h = h < 10 ? "0" + h : h;
    let m = d.getMinutes();
    m = m < 10 ? "0" + m : m;
    var ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12;
    h = h ? h : 12; // the hour '0' should be '12'
    // m = m < 10 ? '0'+ m : m;
    let day = d.getDate();
    day = day < 10 ? "0" + day : day;

    return ` ${day} ${months[d.getMonth()]}  ${d.getFullYear()}, ${h}:${m} ${ampm} `
}

export const convertDateToUTC = (date: Date) =>  { 
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds()); 
}


const dateOnly = (date: any) => {
    if (!date) {
        date = new Date();
    }

    if (typeof date == "string") {
        date = new Date(date);
    }

    let d = date;
    
    let day = d.getDate();
    day = day < 10 ? "0" + day : day;
    return ` ${day} ${months[d.getMonth()]} ${d.getFullYear()}`
}

const dateFromString = (date: any) => {
    date = new Date(date)
    return ` ${date.getDate()} ${date.toLocaleString('default', { month: 'long' })} ${date.getFullYear()}`
}

const dateTime = (date: any) => {
    if (!date) {
        date = new Date();
    }

    if (typeof date == "string") {
        date = new Date(date);
    }

    let d = date;
    let h = d.getHours();
    h = h < 10 ? "0" + h : h;
    let m = d.getMinutes();
    m = m < 10 ? "0" + m : m;
    let s = d.getSeconds();
    s = s < 10 ? "0" + s : s;
    let day = d.getDate();
    day = day < 10 ? "0" + day : day;
    let month = d.getMonth() + 1;
    month = month < 10 ? "0" + month : month;

    return `${day}/${month}/${d.getFullYear()} at ${h}:${m}:${s}`
}

const getTimeAgo = (provided: any) => {
    const msPMin = 60 * 1000;
    const msPHr = msPMin * 60;
    const msPDay = msPHr * 24;
    const msPWeek = msPDay * 7;
    const msPMon = msPDay * 30;
    const msPYr = msPMon * 365;

    const elapsed = Date.now() - Date.parse(provided);

    if (elapsed < 0) return "0 Sec";

    if (elapsed < msPMin) return Math.round(elapsed / 1000) + "Sec";
    if (elapsed < msPHr) return Math.round(elapsed / msPMin) + "Min";
    if (elapsed < msPDay) return Math.round(elapsed / msPHr) + "H";
    if (elapsed < msPWeek) return Math.round(elapsed / msPDay) + "D";
    if (elapsed < msPMon) return Math.round(elapsed / msPWeek) + "W";
    if (elapsed < msPYr) return Math.round(elapsed / msPMon) + "M";
    return Math.round(elapsed / msPYr) + "Y";
}

const dateISOtoYMD = (date: any) => {
    if (!date) {
        date = new Date();
    }

    if (typeof date == "string") {
        date = new Date(date);
    }

    let d = date;
    let h = d.getHours();
    h = h < 10 ? "0" + h : h;
    let m = d.getMinutes();
    m = m < 10 ? "0" + m : m;
    let s = d.getSeconds();
    s = s < 10 ? "0" + s : s;
    let day = d.getDate();
    day = day < 10 ? "0" + day : day;
    let month = d.getMonth() + 1;
    month = month < 10 ? "0" + month : month;

    return `${d.getFullYear()}-${month}-${day}`
}
const dateYMDHHMMSSToISO=(input:string)=>{
    if(input==null||input==undefined){
        return "";
    }
    // 24/03/2021 13:30:00
    // const datePart=date.substring(0,10);
      let [datePart,timePart]=input.split(" ");
      const dateOnly=datePart.split("/").reverse().join("-");
      const timeOnly='T'+timePart+'.000Z';
    //   JSON.stringify(new Date(date[2], date[1], ,2, 15, 4, 5))
    const date=new Date(dateOnly+timeOnly);
    
    const newDate= convertDateToUTC(date).toString();
    
   return newDate;
}

const dateInStandardJSFormat = (input: string) => {
    if(input==null||input==undefined){
        return "";
    }
    let [datePart,timePart]=input.split(" ");
    const dateOnly=datePart.split("/").reverse().join("-");
    const timeOnly='T'+timePart+'.000Z';
    const date = `${dateOnly}${timeOnly}`;
    return date;
}

const getTimeStamp = (utcDateString: any) => {
    const date = new Date(utcDateString);
    const now = new Date();
    const diffSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    for (let interval of INTERVALS_VARIABLES) {
        if (diffSeconds < interval.threshold) {
            if (!interval.divisor) {
                return interval.label.replace('%d %b %Y', dateOnly(utcDateString));
            }
            const strVal = Math.floor(diffSeconds / interval.divisor).toString(); 
            return interval.label.replace('%d', strVal);
        }
    }
}

function convertDate(dateStr: string): string {
    if (!dateStr) return '';
    const [day, monthAbbr, year] = dateStr.trim().split(' ');
    const monthMap: { [key: string]: string } = {
        Jan: 'January', Feb: 'February', Mar: 'March', Apr: 'April', May: 'May', Jun: 'June',
        Jul: 'July', Aug: 'August', Sep: 'September', Oct: 'October', Nov: 'November', Dec: 'December'
    };

    const monthFull = monthMap[monthAbbr];

    if (!monthFull) {
        throw new Error(`Invalid month abbreviation: ${monthAbbr}`);
    }
    return `${day} ${monthFull} ${year}`;
}
const dateService = {
    timeSince,
    timeDate,
    dateTime,
    getTimeAgo,
    dateISOtoYMD,
    dateOnly,
    dateFromString,
    dateYMDHHMMSSToISO,
    dateInStandardJSFormat,
    getTimeStamp,
    convertDate
}

export default dateService;